/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/interface-name-prefix */
/**
 * 因为没有用vuex
 * 使用单例 来同步case数据
 * 子页面里，点击保存就要更新这里的数据
 */

import { definitions } from '@/types/api';

/** 基本信息 */
export interface ICaseInfo {
  caseId?: string; // 案例id
  caseName?: string; // 案例名称
  caseModule?: string; // 案例模块
  caseUnit?: number[]; // 案例单元——对应单元实验的index 最大和最小
  caseDifficulty?: number; // 案例难度
  caseInfomation?: string; // 案例信息
  caseImg?: string; // 案例封面
}
/** 单元实验-每个个体 */
export interface IUnitExperiment {
  parentId: number; // 类型Id,0-风险分析研判,1-推演对象分析,2-情景任务清单,3-应急能力评估,4-推演方案评估,5-推演方案制定,6-演练结果复盘,7-应急预案优化
  unitTaskTarget: string; // 任务目标
  unitTaskDescription: string; // 任务描述
  unitExperimentObjective: string; // 单元实验目的
  unitReadyKnowledge: string; // 单元准备知识
  unitDescription: string; // 单元准备描述
  unitImg: string; // 单元实验流程
  unitTimeMode: number; // 单元实验计时方式
  unitEndConditionList: definitions['CustomUnitEndCondition'][]; // 单元实验结束条件
  endInfo: string; // 阶段结束提示
}
/** 情景构建 */
export interface IScenarioConstruction {

}
/** 评分系统 */
export interface IScoringSystem {

}

type unitExperiment = Record<string, IUnitExperiment>; // 每个索引对应 - 单元实验
// export interface ICustomCaseClass {
//   /** 案例信息 */
//   caseInfo?: ICaseInfo;
//   /** 单元实验 */
//   unitExperiment?: unitExperiment[];
//   /** 情景构建 */
//   scenarioConstruction?: IScenarioConstruction;
//   /** 评分系统 */
//   scoringSystem?: IScoringSystem;
// }

// type CaseDataKeys = 'caseInfo' | 'unitExperiment' | 'scenarioConstruction' | 'scoringSystem'; // caseData键
export class CustomCaseClass {
  /** data */
  caseInfo?: ICaseInfo;

  unitExperiment?: IUnitExperiment[];

  scenarioConstruction?: IScenarioConstruction;

  scoringSystem?: IScoringSystem;

  /** method */
  /** 检测单元实验有没有完成 */
  checkUnitExperiment() {
    // console.log(this, 'this');
    const { caseInfo, unitExperiment } = this;
    const { caseUnit } = (caseInfo as ICaseInfo);
    const caseUnitArr: number[] = []; // 1,2,3,4,5
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for (let i = caseUnit![0]; i <= caseUnit![1]; i += 1) {
      caseUnitArr.push(i);
    }
    console.log(unitExperiment, caseUnitArr, 'unit');
    if (unitExperiment && unitExperiment.length) {
      const unitExs = unitExperiment.map((u) => u.parentId); // 现在保存了的单元实验pid  1,2
      return caseUnitArr.every((i: number) => unitExs.includes(i));
    }
    return false;
  }

  /** 检测情景构建有没有完成 */
  checkScenario() {
    return false;
  }

  /** 单例方法 */
  private static instance?: CustomCaseClass; // 实例

  /** 获得实例 */
  public static getInstance(data: any) {
    if (!CustomCaseClass.instance) {
      CustomCaseClass.instance = new CustomCaseClass(data);
    }
    return CustomCaseClass.instance;
  }

  /** 删除实例 */
  public static removeInstance() {
    CustomCaseClass.instance = undefined;
  }

  private constructor(data: any) {
    console.log('this is constructor', data);
  }
}
